import { Progress } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const ProgressLine = ({ percent, color, vertical }) => {
    return (
        <Progress.Line percent={percent} strokeColor={color} vertical={vertical} showInfo={false} strokeWidth={36} />
    );
}

export default ProgressLine;